import { DropdownOption } from 'components/final-form/dropdownUtils';

export const previousDosesOptions = (getMessage: (key: string) => string): DropdownOption[] => {
  return [1, 2, 3, 4, 5].map(option => ({
    key: option,
    text: getMessage(`boosterDoseOption.${option}`),
    value: option
  }));
};
